import React from "react";
import { Redirect } from "react-router";
import NavbarBpw from "../generalComponents/NavbarBpw";

export const DataVersionApp = () => {
	const jsonValue = localStorage.getItem("userLocal");
	const localUser = JSON.parse(jsonValue);

	return (
		<div>
			{localUser.type === "1" ? (
				<div>
					<NavbarBpw />
					<aritcle className="titulo9">
						Versión: ProductionV03 github Octubre 04 2026 (actualización
						buscador cursos)
					</aritcle>
					<aritcle className="titulo9">
						Versión: ProductionV03 github Diciembre 04 2025-2 (cambia la manera
						de ver material de capacitación porque en teléfono sno se estaba
						viendo bien )
					</aritcle>

					<aritcle className="titulo9">
						Versión: ProductionV03 github Noviembre 16 2025 (mejora en medición
						del tiempo de elaboración de cursos )
					</aritcle>
					<br></br>
					<aritcle className="titulo9">
						Versión: ProductionV03 github Septiembre 28 2025 (Evaluaciones, el
						administrador puede ver el detalle de cómo respondieron los
						estudiantes, 2. se estableció un registro de tiempo de ejecución de
						la capacitación por cada estudiante )
					</aritcle>
					<br></br>
					<aritcle className="titulo9">
						Versión: ProductionV03 github Noviembre 04 2024 (Reorganización de
						tareas por fecha, realizado desde la apilcación ya no desde la base
						de datos. )
					</aritcle>
					<br></br>
					<aritcle className="titulo9">
						Versión: ProductionV03 github Octubre 13 2024 (creación de usuarios
						desde cada empresa )
					</aritcle>
				</div>
			) : (
				<Redirect to="/intruso" />
			)}
		</div>
	);
};
